import StreetviewIcon from "@material-ui/icons/Streetview";
import ReferenceTypeList from "./ReferenceTypeList";

export default {
  list: ReferenceTypeList,
  icon: StreetviewIcon,
};
